import { render, staticRenderFns } from "./adjustResultNote.vue?vue&type=template&id=27d11ef8&scoped=true&"
import script from "./adjustResultNote.vue?vue&type=script&lang=js&"
export * from "./adjustResultNote.vue?vue&type=script&lang=js&"
import style0 from "./adjustResultNote.vue?vue&type=style&index=0&id=27d11ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d11ef8",
  null
  
)

export default component.exports